// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ErrorViewCmp from "../ErrorViewCmp.bs.js";
import * as SendSMSAssetsManager from "../../assets/SendSMSAssetsManager.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";

var delete_icon = SendSMSAssetsManager.getImage("delete-icon.svg");

function TemplateListCmp(Props) {
  var template_list = Props.template_list;
  var row_function = Props.row_function;
  var getColumnSchema = function (param) {
    return {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Title"
              },
              accessor: (function (data) {
                  return {
                          TAG: /* Text */0,
                          _0: data.template_title
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Template ID"
                },
                accessor: (function (data) {
                    return {
                            TAG: /* Text */0,
                            _0: String(data.template_id)
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Message"
                  },
                  accessor: (function (data) {
                      return {
                              TAG: /* Text */0,
                              _0: data.template_message
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: "Delete Template"
                    },
                    accessor: (function (data) {
                        return {
                                TAG: /* Custom */5,
                                _0: (function (param) {
                                    return React.createElement("div", {
                                                className: "delete-img-container"
                                              }, React.createElement("img", {
                                                    src: delete_icon,
                                                    onClick: (function (_event) {
                                                        return Curry._1(row_function, data.template_id);
                                                      })
                                                  }));
                                  })
                              };
                      })
                  },
                  tl: /* [] */0
                }
              }
            }
          };
  };
  return React.createElement("div", {
              className: "c-message-template-list"
            }, List.length(template_list) === 0 ? React.createElement(ErrorViewCmp.make, {
                    message: "No Template ID found"
                  }) : React.createElement(TableComponent$Catalyst.make, {
                    columns: getColumnSchema(undefined),
                    rowData: template_list
                  }));
}

var make = TemplateListCmp;

export {
  delete_icon ,
  make ,
  
}
/* delete_icon Not a pure module */
